import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

const CookieConsentBanner: React.FC = () => {
  const { consent, acceptAll, acceptEssentialOnly, openSettingsDialog } = useCookieConsent();

  if (consent.resolved) return null;

  return (
    <Box sx={{ position: 'fixed', bottom: 64, left: 12, right: 12, zIndex: 1400 }}>
      <Alert severity="info" sx={{ alignItems: 'center' }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ sm: 'center' }}>
          <Typography variant="body2">
            We use essential cookies for login and security. Optional cookies are off until you choose otherwise.
          </Typography>
          <Button size="small" variant="contained" onClick={acceptAll}>Accept all</Button>
          <Button size="small" variant="outlined" onClick={acceptEssentialOnly}>Essential only</Button>
          <Button size="small" onClick={openSettingsDialog}>Cookie Settings</Button>
        </Stack>
      </Alert>
    </Box>
  );
};

export default CookieConsentBanner;
